import { render, staticRenderFns } from "./SimpleList.vue?vue&type=template&id=662c4cac&scoped=true&"
import script from "./SimpleList.vue?vue&type=script&lang=js&"
export * from "./SimpleList.vue?vue&type=script&lang=js&"
import style0 from "./SimpleList.vue?vue&type=style&index=0&id=662c4cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662c4cac",
  null
  
)

export default component.exports